import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import * as S from "./style"; // Importando os Styled Components

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

// Import required modules
import {Autoplay, FreeMode, Pagination } from 'swiper/modules';

import slide_image1 from '../../images/provasocial/1.jpg';
import slide_image2 from '../../images/provasocial/2.jpg';
import slide_image3 from '../../images/provasocial/3.jpg';
import slide_image4 from '../../images/provasocial/4.jpg';
import slide_image5 from '../../images/provasocial/5.jpg';
import slide_image6 from '../../images/provasocial/6.jpg';

export default function SwiperCarrossel() {
  return (
    <S.Container>
      <S.SwiperContainer>
        <Swiper
          autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
          slidesPerView={3}  // Padrão: 3 slides visíveis
          spaceBetween={30}  // Espaçamento entre os slides
          freeMode={true}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          loop={true}  // Faz o carrossel ser infinito
          breakpoints={{
            320: {  // Para telas pequenas (como celulares)
              slidesPerView: 1, // Exibe apenas 1 slide por vez no mobile
              spaceBetween: 10, // Menos espaço entre os slides no mobile
            },
            768: {  // Para telas médias (como tablets)
              slidesPerView: 2, // Exibe 2 slides por vez em tablets
              spaceBetween: 20,
            },
            1024: {  // Para telas grandes
              slidesPerView: 3, // Exibe 3 slides por vez em desktops
              spaceBetween: 30,
            },
          }}
        >
          <SwiperSlide>
            <S.Image src={slide_image1} alt="slide_image" />
          </SwiperSlide>
          <SwiperSlide>
            <S.Image src={slide_image2} alt="slide_image" />
          </SwiperSlide>
          <SwiperSlide>
            <S.Image src={slide_image3} alt="slide_image" />
          </SwiperSlide>
          <SwiperSlide>
            <S.Image src={slide_image4} alt="slide_image" />
          </SwiperSlide>
          <SwiperSlide>
            <S.Image src={slide_image5} alt="slide_image" />
          </SwiperSlide>
          <SwiperSlide>
            <S.Image src={slide_image6} alt="slide_image" />
          </SwiperSlide>
        </Swiper>
      </S.SwiperContainer>
    </S.Container>
  );
}
